
import {  Skills } from '@/models/Resume'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    name: "skills",
    props: {
        skills: {
            type: Skills,
            required: true
        } 
    }
})
